var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCopyUrl = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.72834C0 5.27647 0.366312 4.91016 0.818182 4.91016H10.6364C11.0882 4.91016 11.4545 5.27647 11.4545 5.72834V17.1829C11.4545 17.6348 11.0882 18.0011 10.6364 18.0011H0.818182C0.366312 18.0011 0 17.6348 0 17.1829V5.72834ZM1.63636 6.54652V16.3647H9.81818V6.54652H1.63636Z",
    fill: "#8D939C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27246 0.81867C3.27246 0.366801 3.63877 0.000488281 4.09064 0.000488281H13.9088C14.3607 0.000488281 14.727 0.366801 14.727 0.81867V12.2732C14.727 12.7251 14.3607 13.0914 13.9088 13.0914H10.6361V11.455H13.0906V1.63685H4.90882V5.72776H3.27246V0.81867Z",
    fill: "#8D939C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCopyUrl);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_copy_url.6ed78f3504198715ff39c7afc50f284b.svg";